/**
 * Request 1165 — older birthday / anniversary notifications were sent without a link: work out the Celebrations page for
 * the month they talk about from the title ("Upcoming birthdays & work anniversaries — November 2026" or "Tomorrow (26 Oct): …").
 */
const MONTHS = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
export function celebrationLink(title: string | null | undefined, createdAt?: string): string | null {
  const t = title ?? "";
  const a = /birthdays & work anniversaries — (\w+) (\d{4})/i.exec(t);
  if (a) {
    const m = MONTHS.indexOf(a[1].toLowerCase());
    if (m >= 0) return `/hrms/celebrations?month=${a[2]}-${String(m + 1).padStart(2, "0")}`;
  }
  const b = /^Tomorrow \((\d{1,2}) (\w{3})\)/i.exec(t);
  if (b) {
    const m = MONTHS.findIndex((x) => x.startsWith(b[2].toLowerCase()));
    if (m >= 0) {
      const sent = createdAt ? new Date(createdAt) : new Date();
      const year = sent.getMonth() === 11 && m === 0 ? sent.getFullYear() + 1 : sent.getFullYear();
      return `/hrms/celebrations?month=${year}-${String(m + 1).padStart(2, "0")}`;
    }
  }
  return null;
}
